import { compose } from 'recompose';
import UserPicker from '../../features/fields/UserPicker';
import { queryGetAllContactUsersGQL } from './graphql/queryGetAllContactUsersGQL';

const enhance = compose(queryGetAllContactUsersGQL);

export default enhance(UserPicker);
